import { createContext, useContext, useState, useEffect, useCallback } from "react";

const translations = {
  it: {
    "nav.shop": "Il Nostro Miele",
    "nav.manifesto": "Manifesto",
    "nav.courses": "Formazione",
    "nav.about": "Chi Siamo",
    "nav.admin": "Backoffice",
    "nav.login": "Accedi",
    "nav.logout": "Esci",
    "nav.account": "Il Mio Account",
    "hero.badge": "Lotto corrente #2026-04 — Acacia & Castagno",
    "hero.line1": "Miele puro,",
    "hero.line2": "mielato a mano",
    "hero.line3": "nella Lomellina.",
    "hero.sub": "Dalle fioriture spontanee delle terre lombarde, un miele grezzo e non pastorizzato, prodotto secondo la tradizione apistica di famiglia.",
    "hero.cta1": "Esplora la Collezione",
    "hero.cta2": "Prenota un Corso in Apiario",
    "hero.scroll": "Scorri per scoprire",
    "marquee": "100% NATURALE • NON PASTORIZZATO • APICOLTURA SOSTENIBILE • MIELE DI ACACIA • MIELE MILLEFIORI • POLLINE E PAPPA REALE • PROPOLI • CORSI PRATICI IN APIARIO • ",
    "manifesto.eyebrow": "Il nostro manifesto",
    "manifesto.title": "Tre promesse, un solo mestiere.",
    "manifesto.1.title": "Rispetto per le Api",
    "manifesto.1.desc": "Nessun trattamento chimico di sintesi. Lasciamo sempre alle nostre famiglie di api la loro scorta naturale di miele per l'inverno.",
    "manifesto.2.title": "Territorio della Lomellina",
    "manifesto.2.desc": "Tra rogge, garzaie e boschi di acacia, posizioniamo gli apiari lontano da contaminazioni industriali.",
    "manifesto.3.title": "Mielatura a Freddo",
    "manifesto.3.desc": "Estrazione meccanica per centrifugazione a temperatura ambiente. Manteniamo intatti enzimi, polline e profumi originali.",
    "home.featured.eyebrow": "La raccolta",
    "home.featured.title": "I mieli del momento",
    "home.featured.cta": "Vai al negozio",
    "home.courses.eyebrow": "Formazione in apiario",
    "home.courses.title": "Impara il mestiere delle api",
    "home.courses.cta": "Scopri tutti i corsi",
    "shop.title": "Il Nostro Miele",
    "shop.sub": "Mieli monoflora, polline, pappa reale e propoli. Tutto nasce nei nostri apiari in Lomellina.",
    "shop.all": "Tutti",
    "cat.mieli": "Mieli",
    "cat.polline": "Polline & Pappa Reale",
    "cat.propoli": "Propoli & Integratori",
    "cat.regalo": "Confezioni Regalo",
    "shop.sort.featured": "Consigliati",
    "shop.sort.asc": "Prezzo crescente",
    "shop.sort.desc": "Prezzo decrescente",
    "product.add": "Aggiungi",
    "product.from": "da",
    "pdp.harvest": "Raccolta",
    "pdp.batch": "Lotto",
    "pdp.origin": "Origine botanica",
    "pdp.provenance": "Provenienza",
    "pdp.apiary": "Apiario di Lomellina — 45.18°N, 8.72°E",
    "pdp.size": "Formato",
    "pdp.qty": "Quantità",
    "pdp.addcart": "Aggiungi al carrello",
    "pdp.tasting": "Note di degustazione",
    "pdp.pairings": "Abbinamenti",
    "pdp.related": "Potrebbe piacerti anche",
    "taste.dolcezza": "Dolcezza",
    "taste.aromaticita": "Aromaticità",
    "taste.cristallizzazione": "Cristallizzazione",
    "taste.persistenza": "Persistenza",
    "cart.title": "Il tuo carrello",
    "cart.empty": "Il carrello è vuoto",
    "cart.empty.cta": "Scopri i nostri mieli",
    "cart.subtotal": "Subtotale",
    "cart.shipping": "Spedizione",
    "cart.free": "Gratuita",
    "cart.total": "Totale",
    "cart.checkout": "Vai alla cassa",
    "cart.free.progress": "Ti mancano {x} per la spedizione gratuita",
    "cart.free.done": "Hai la spedizione gratuita!",
    "cart.remove": "Rimuovi",
    "checkout.title": "Cassa",
    "checkout.contact": "Dati di contatto e spedizione",
    "checkout.name": "Nome e cognome",
    "checkout.email": "Email",
    "checkout.phone": "Telefono",
    "checkout.address": "Indirizzo",
    "checkout.city": "Città",
    "checkout.zip": "CAP",
    "checkout.pay": "Paga con carta o PayPal",
    "checkout.secure": "Pagamento sicuro via Stripe. Puoi pagare con carta di credito o PayPal.",
    "checkout.login.hint": "Hai un account? Accedi per salvare lo storico ordini.",
    "pay.success.title": "Grazie per il tuo ordine!",
    "pay.success.sub": "Il pagamento è andato a buon fine. Ti invieremo un'email con i dettagli della spedizione.",
    "pay.success.order": "Numero ordine",
    "pay.success.cta": "Torna al negozio",
    "pay.pending": "Stiamo confermando il pagamento…",
    "pay.cancel.title": "Pagamento annullato",
    "pay.cancel.sub": "Nessun addebito è stato effettuato. Il tuo carrello è ancora qui.",
    "pay.cancel.cta": "Riprova",
    "auth.login": "Accedi",
    "auth.register": "Registrati",
    "auth.name": "Nome",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.login.cta": "Entra nel tuo account",
    "auth.register.cta": "Crea account",
    "auth.no.account": "Non hai un account?",
    "auth.has.account": "Hai già un account?",
    "account.title": "Il mio account",
    "account.orders": "I miei ordini",
    "account.wishlist": "Wishlist",
    "account.profile": "Profilo",
    "account.no.orders": "Nessun ordine ancora. Il primo vasetto ti aspetta!",
    "account.wishlist.empty": "La wishlist è vuota.",
    "order.status.in_attesa_pagamento": "In attesa di pagamento",
    "order.status.nuovo": "Nuovo",
    "order.status.in_lavorazione": "In lavorazione",
    "order.status.spedito": "Spedito",
    "order.status.consegnato": "Consegnato",
    "order.status.annullato": "Annullato",
    "courses.title": "Formazione e Laboratori Apistici",
    "courses.sub": "Corsi pratici nei nostri apiari in Lomellina, per tutti i livelli.",
    "courses.book": "Prenota il tuo posto",
    "courses.dates": "Prossime date",
    "courses.seats": "posti",
    "courses.level": "Livello",
    "courses.includes": "Include",
    "courses.form.title": "Richiesta di prenotazione",
    "courses.form.date": "Data preferita",
    "courses.form.participants": "Partecipanti",
    "courses.form.notes": "Note",
    "courses.form.submit": "Invia richiesta",
    "courses.form.success": "Richiesta inviata! Ti contatteremo per confermare il posto.",
    "about.eyebrow": "Chi siamo",
    "about.title": "Una famiglia, un territorio, un miele.",
    "about.p1": "LoMIELlina nasce nel cuore della Lomellina, tra le rogge e le garzaie della bassa pianura lombarda. Da generazioni alleviamo api con un unico principio: lasciare che sia la natura a dettare i tempi.",
    "about.p2": "Ogni vasetto è mielato a mano, mai pastorizzato, mai filtrato a caldo. Quello che assaggi è esattamente quello che le api hanno raccolto.",
    "about.p3": "Oggi apriamo le porte dei nostri apiari con corsi e laboratori, perché crediamo che il futuro delle api passi dalla conoscenza.",
    "footer.tagline": "Apicoltura artigianale in Lomellina. Miele grezzo, non pastorizzato, mielato a mano.",
    "footer.shop": "Negozio",
    "footer.company": "Azienda",
    "footer.contacts": "Contatti",
    "footer.rights": "© 2026 LoMIELlina — Apicoltura in Lomellina. Tutti i diritti riservati.",
    "common.added": "Aggiunto al carrello",
    "common.wishlist.add": "Aggiunto alla wishlist",
    "common.wishlist.remove": "Rimosso dalla wishlist",
    "common.loading": "Caricamento…",
    "admin.title": "Backoffice LoMIELlina",
    "admin.dashboard": "Dashboard",
    "admin.products": "Prodotti",
    "admin.orders": "Ordini",
    "admin.courses": "Corsi",
    "admin.customers": "Clienti",
    "admin.revenue": "Fatturato",
    "admin.jars": "Vasetti venduti",
    "admin.tofulfill": "Ordini da evadere",
    "admin.bookings": "Iscritti ai corsi",
    "admin.sales.by.cat": "Vendite per categoria",
    "admin.recent": "Ultimi ordini",
    "admin.new.product": "Nuovo prodotto",
    "admin.edit": "Modifica",
    "admin.delete": "Elimina",
    "admin.save": "Salva",
    "admin.cancel": "Annulla",
    "admin.login.required": "Accedi con un account amministratore per entrare nel backoffice.",
  },
  en: {
    "nav.shop": "Our Honey",
    "nav.manifesto": "Manifesto",
    "nav.courses": "Courses",
    "nav.about": "About Us",
    "nav.admin": "Backoffice",
    "nav.login": "Sign in",
    "nav.logout": "Sign out",
    "nav.account": "My Account",
    "hero.badge": "Current batch #2026-04 — Acacia & Chestnut",
    "hero.line1": "Pure honey,",
    "hero.line2": "hand-extracted",
    "hero.line3": "in Lomellina.",
    "hero.sub": "From the wild blooms of the Lombard lowlands, a raw, unpasteurised honey made following our family's beekeeping tradition.",
    "hero.cta1": "Explore the Collection",
    "hero.cta2": "Book an Apiary Course",
    "hero.scroll": "Scroll to discover",
    "marquee": "100% NATURAL • UNPASTEURISED • SUSTAINABLE BEEKEEPING • ACACIA HONEY • WILDFLOWER HONEY • POLLEN & ROYAL JELLY • PROPOLIS • HANDS-ON APIARY COURSES • ",
    "manifesto.eyebrow": "Our manifesto",
    "manifesto.title": "Three promises, one craft.",
    "manifesto.1.title": "Respect for Bees",
    "manifesto.1.desc": "No synthetic chemical treatments. We always leave our colonies their natural honey reserve for the winter.",
    "manifesto.2.title": "The Lomellina Territory",
    "manifesto.2.desc": "Between canals, heronries and acacia woods, we place our apiaries far from industrial contamination.",
    "manifesto.3.title": "Cold Extraction",
    "manifesto.3.desc": "Mechanical centrifuge extraction at room temperature. We keep enzymes, pollen and original aromas intact.",
    "home.featured.eyebrow": "The harvest",
    "home.featured.title": "Honeys of the moment",
    "home.featured.cta": "Go to the shop",
    "home.courses.eyebrow": "Apiary training",
    "home.courses.title": "Learn the craft of bees",
    "home.courses.cta": "Discover all courses",
    "shop.title": "Our Honey",
    "shop.sub": "Monofloral honeys, pollen, royal jelly and propolis. Everything is born in our Lomellina apiaries.",
    "shop.all": "All",
    "cat.mieli": "Honeys",
    "cat.polline": "Pollen & Royal Jelly",
    "cat.propoli": "Propolis & Supplements",
    "cat.regalo": "Gift Boxes",
    "shop.sort.featured": "Featured",
    "shop.sort.asc": "Price: low to high",
    "shop.sort.desc": "Price: high to low",
    "product.add": "Add",
    "product.from": "from",
    "pdp.harvest": "Harvest",
    "pdp.batch": "Batch",
    "pdp.origin": "Botanical origin",
    "pdp.provenance": "Provenance",
    "pdp.apiary": "Lomellina Apiary — 45.18°N, 8.72°E",
    "pdp.size": "Size",
    "pdp.qty": "Quantity",
    "pdp.addcart": "Add to cart",
    "pdp.tasting": "Tasting notes",
    "pdp.pairings": "Pairings",
    "pdp.related": "You may also like",
    "taste.dolcezza": "Sweetness",
    "taste.aromaticita": "Aromatic intensity",
    "taste.cristallizzazione": "Crystallisation",
    "taste.persistenza": "Persistence",
    "cart.title": "Your cart",
    "cart.empty": "Your cart is empty",
    "cart.empty.cta": "Discover our honeys",
    "cart.subtotal": "Subtotal",
    "cart.shipping": "Shipping",
    "cart.free": "Free",
    "cart.total": "Total",
    "cart.checkout": "Checkout",
    "cart.free.progress": "{x} away from free shipping",
    "cart.free.done": "You have free shipping!",
    "cart.remove": "Remove",
    "checkout.title": "Checkout",
    "checkout.contact": "Contact & shipping details",
    "checkout.name": "Full name",
    "checkout.email": "Email",
    "checkout.phone": "Phone",
    "checkout.address": "Address",
    "checkout.city": "City",
    "checkout.zip": "ZIP code",
    "checkout.pay": "Pay by card or PayPal",
    "checkout.secure": "Secure payment via Stripe. You can pay by credit card or PayPal.",
    "checkout.login.hint": "Have an account? Sign in to keep your order history.",
    "pay.success.title": "Thank you for your order!",
    "pay.success.sub": "Your payment went through. We'll email you the shipping details.",
    "pay.success.order": "Order number",
    "pay.success.cta": "Back to the shop",
    "pay.pending": "Confirming your payment…",
    "pay.cancel.title": "Payment cancelled",
    "pay.cancel.sub": "No charge was made. Your cart is still here.",
    "pay.cancel.cta": "Try again",
    "auth.login": "Sign in",
    "auth.register": "Sign up",
    "auth.name": "Name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.login.cta": "Sign in to your account",
    "auth.register.cta": "Create account",
    "auth.no.account": "Don't have an account?",
    "auth.has.account": "Already have an account?",
    "account.title": "My account",
    "account.orders": "My orders",
    "account.wishlist": "Wishlist",
    "account.profile": "Profile",
    "account.no.orders": "No orders yet. Your first jar is waiting!",
    "account.wishlist.empty": "Your wishlist is empty.",
    "order.status.in_attesa_pagamento": "Awaiting payment",
    "order.status.nuovo": "New",
    "order.status.in_lavorazione": "Processing",
    "order.status.spedito": "Shipped",
    "order.status.consegnato": "Delivered",
    "order.status.annullato": "Cancelled",
    "courses.title": "Beekeeping Courses & Workshops",
    "courses.sub": "Hands-on courses in our Lomellina apiaries, for all levels.",
    "courses.book": "Book your seat",
    "courses.dates": "Upcoming dates",
    "courses.seats": "seats",
    "courses.level": "Level",
    "courses.includes": "Includes",
    "courses.form.title": "Booking request",
    "courses.form.date": "Preferred date",
    "courses.form.participants": "Participants",
    "courses.form.notes": "Notes",
    "courses.form.submit": "Send request",
    "courses.form.success": "Request sent! We'll contact you to confirm your seat.",
    "about.eyebrow": "About us",
    "about.title": "One family, one land, one honey.",
    "about.p1": "LoMIELlina was born in the heart of Lomellina, among the canals and heronries of the Lombard lowlands. For generations we have kept bees with a single principle: let nature set the pace.",
    "about.p2": "Every jar is hand-extracted, never pasteurised, never hot-filtered. What you taste is exactly what the bees gathered.",
    "about.p3": "Today we open our apiary doors with courses and workshops, because we believe the future of bees comes through knowledge.",
    "footer.tagline": "Artisanal beekeeping in Lomellina. Raw, unpasteurised, hand-extracted honey.",
    "footer.shop": "Shop",
    "footer.company": "Company",
    "footer.contacts": "Contacts",
    "footer.rights": "© 2026 LoMIELlina — Beekeeping in Lomellina. All rights reserved.",
    "common.added": "Added to cart",
    "common.wishlist.add": "Added to wishlist",
    "common.wishlist.remove": "Removed from wishlist",
    "common.loading": "Loading…",
    "admin.title": "LoMIELlina Backoffice",
    "admin.dashboard": "Dashboard",
    "admin.products": "Products",
    "admin.orders": "Orders",
    "admin.courses": "Courses",
    "admin.customers": "Customers",
    "admin.revenue": "Revenue",
    "admin.jars": "Jars sold",
    "admin.tofulfill": "Orders to fulfil",
    "admin.bookings": "Course signups",
    "admin.sales.by.cat": "Sales by category",
    "admin.recent": "Latest orders",
    "admin.new.product": "New product",
    "admin.edit": "Edit",
    "admin.delete": "Delete",
    "admin.save": "Save",
    "admin.cancel": "Cancel",
    "admin.login.required": "Sign in with an administrator account to enter the backoffice.",
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lm_lang") || "it");
  useEffect(() => {
    localStorage.setItem("lm_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = useCallback((key) => translations[lang]?.[key] ?? translations.it[key] ?? key, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
